<template>
  <v-text-field
    :label="label"
    :value="amount"
    inputmode="decimal"
    :error-messages="errors"
    @input="updateAmount"
  >
    <template #append-outer>
      <div class="currency-symbol">
        <v-menu>
          <template v-slot:activator="{ attrs, on }">
            <span v-bind="attrs" v-on="on">{{ selectedCurrency.symbol }}</span>
          </template>
          <v-list>
            <v-list-item-group :value="selectedCurrency.code">
              <v-list-item
                v-for="currency of $options.currencies"
                :key="currency.code"
                :value="currency.code"
                @click="updateCurrency(currency.code)"
              >
                <v-list-item-title>
                  <strong>{{ currency.code }}</strong>
                  {{ currency.name }}
                </v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
      </div>
    </template>
  </v-text-field>
</template>

<script>
const currencies = [
  { name: "Гривня", code: "UAH", symbol: "₴" },
  { name: "Євро", code: "EUR", symbol: "€" },
  { name: "Долар", code: "USD", symbol: "$" },
];

export default {
  name: "MoneyField",
  props: {
    amount: {
      type: [Number, String],
      default: null,
    },
    currency: {
      type: String,
      default: "UAH",
      validator(value) {
        return currencies.map((currency) => currency.code).includes(value);
      },
    },
    label: {
      type: String,
      default: "Сума",
    },
    errors: {
      type: Array,
      default: () => [],
    },
  },
  currencies,
  computed: {
    selectedCurrency() {
      return this.$options.currencies.find(
        (currency) => currency.code === this.currency
      );
    },
  },
  methods: {
    updateAmount(amount) {
      this.$emit("change");
      this.$emit("update:amount", amount);
    },
    updateCurrency(currency) {
      this.$emit("change");
      this.$emit("update:currency", currency);
    },
  },
};
</script>

<style lang="scss" scoped>
.currency-symbol {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  margin: -4px -9px;
}
</style>
